import React, { PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Swal from "sweetalert2";

import { SiteRutas } from "../../request/RutasConfig";
import { Repartidor_Eliminar, Repartidores_Lista } from "../../request/MantenimientosRequest";
import { Obtener_CallCenter_Empresa_Request } from "../../request/ParametroRequest";
import { Obtener_MenuOpciones } from "../../request/MenuRequest";
import { Notificacion } from "../../components/Util/Notificacion/Notificacion";
import RepartidorItfz from "./Interfaz/repartidorIntfz.jsx";

class Repartidores extends PureComponent {
    _isMounted = false;

    state = {
        Datos: {
            titulo: "Lista de Repartidores",
            CC_id: {
                value: 0,
                attributes: {
                    readOnly: true,
                    focus: false,
                    hidden: "unset",
                    label: "Call Center:",
                    id: "CC_id",
                },
            },
            busqueda: {
                value: "",
                attributes: {
                    readOnly: true,
                    focus: false,
                    hidden: "unset",
                    label: "",
                    id: "busqueda",
                },
            },
        },
        listaCallCenter: [],
        listaRepartidoresOrig: [],
        listaRepartidores: [],
        selectedRepartidor: 0,
        selectedRepEstatus: "",
        selectedCC: 0,
        disabled: {
            Acciones: true,
            HabilitarAplicar: "",
        },
        buscar: "",
        menuId: 0,
        menuOpciones: [],
        showModalSeguridad: false,
        opcionValidar: 0,
        opcionSeleccionada: 1,
        autorizado: false,
        accion: 1,
        paginaActual: 1,
        cantidadRegistrosPaginaTabla: 10
    };

    componentDidMount = async () => {
        this._isMounted = true;

        let menuId = 0;
        if (this.props.location.state) {
            menuId = this.props.location.state.menuId;
        }

        this.obtenerMenuOpciones(menuId);
        this.obtenerCallCenters();
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    obtenerMenuOpciones = async (pMenu_Id) => {
        if (pMenu_Id > 0) {

            const response = await Obtener_MenuOpciones(this.props.token, pMenu_Id);
            if (response.Exitoso) {
                this._isMounted && this.setState({ menuId: pMenu_Id, menuOpciones: response.Datos });
            } else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    obtenerCallCenters = async () => {
        let listaCallCenter = [{ Id: 0, Nombre: "Seleccione una opción" }];

        const response = await Obtener_CallCenter_Empresa_Request(this.props.token, this.props.empresa.Id);
        if (response.Exitoso) {

            if (response.Datos && response.Datos.length > 0) {
                response.Datos.forEach((item) => {
                    listaCallCenter.push({ Id: item.Id, Nombre: item.Nombre });
                });
            }

            this._isMounted && this.setState({ listaCallCenter });
        } else {
            Notificacion.error(response.Mensaje);
        }
    }

    validarMenuOpcion = () => {
        let validar = false;
        let autorizado = this.state.autorizado;
        let menuOpciones = this.state.menuOpciones;
        let resultado = menuOpciones.filter(item => item.Opcion_Id === 1);

        if (resultado.length > 0) {
            if (resultado[0].Validar && !autorizado) {
                this._isMounted && this.setState({ showModalSeguridad: true, opcionValidar: resultado[0].Opcion_Id });
                validar = true;

            } else {
                validar = false;
            }
        } else {
            this._isMounted && this.setState({ showModalSeguridad: true, opcionValidar: 1 });
            validar = true;
        }

        return validar;
    }

    cambiarTamanioPagina = (cantidad) => {
        this.setState({ cantidadRegistrosPaginaTabla: cantidad });
    }

    cambiarPagina = (pagina) => {
        this.setState({ paginaActual: pagina });
    }

    onActionResultModal = (pValido) => {
        if (pValido) {
            const opcionValidar = this.state.opcionValidar;
            this.setState({ showModalSeguridad: false, opcionSeleccionada: opcionValidar, opcionValidar: 0, autorizado: pValido },
                () => {
                    if (this.state.accion === 1) {
                        this.ingresarDatos();
                    } else {
                        this.actualizarDatos();
                    }
                });
        }
    };

    handleCerrarModal = () => this.setState({ showModalSeguridad: false });

    validaSeleccionado = () => {
        let id = this.state.selectedRepartidor;
        if (id) {
            return true;
        } else {
            Notificacion.error("Debe seleccionar un registro");
            return false;
        }
    };

    actualizarDatos = () => {
        let CC_id = this.state.Datos.CC_id.value;

        if (CC_id > 0) {
            if (this.validaSeleccionado()) {
                let validar = this.validarMenuOpcion();

                this._isMounted && this.setState({ accion: 2 });

                if (!validar) {
                    let id = this.state.selectedRepartidor;
                    let Estatus = this.state.selectedRepEstatus;
                    let menuId = this.state.menuId;

                    if (Estatus !== "R") {
                        this.props.history.push({
                            pathname: `${SiteRutas.RepartidorMantenimiento}/${id}/${CC_id}`,
                            state: { menuId: menuId },
                        });
                    } else {
                        Notificacion.warning('El repartidor no puede ser editado porque se encuentra en Ruta.');
                    }
                }
            }
        } else {
            Notificacion.error("Debe seleccionar un Call Center");
        }
    };

    ingresarDatos = () => {
        let CC_id = this.state.Datos.CC_id.value;

        if (CC_id > 0) {
            let validar = this.validarMenuOpcion();

            this._isMounted && this.setState({ accion: 1 });

            if (!validar) {
                let id = 0;

                let menuId = this.state.menuId;
                this.props.history.push({
                    pathname: `${SiteRutas.RepartidorMantenimiento}/${id}/${CC_id}`,
                    state: { menuId: menuId },
                });
            }
        } else {
            Notificacion.error("Debe seleccionar un Call Center");
        }
    };

    borrarDatos = async () => {
        let id = this.state.selectedRepartidor;
        let CC_id = this.state.Datos.CC_id.value;

        if (this.validaSeleccionado()) {

            const resultado = await Repartidor_Eliminar(this.props.token, this.props.empresa.Id, CC_id, id);
            if (resultado.Exitoso) {
                Notificacion.success("Se eliminó con éxito.");

                const response = await Repartidores_Lista(this.props.token, this.props.empresa.Id, CC_id);
                if (response.Exitoso) {
                    let paginaActual = this.state.paginaActual;
                    if (paginaActual > 1 && ((paginaActual - 1) * this.state.cantidadRegistrosPaginaTabla) >= response.Datos.length) {
                        paginaActual--;
                    }

                    this._isMounted && this.setState({ listaRepartidores: response.Datos, listaRepartidoresOrig: response.Datos, selectedRepartidor: "", selectedRepEstatus: "", paginaActual });
                } else {
                    Notificacion.error(response.Mensaje);
                }
            } else {
                Notificacion.error("Error: " + resultado.Mensaje);
            }
        }
    }

    handleBorrar = () => {
        let resultado = false;

        if (this.validaSeleccionado()) {
            Swal.fire({
                title: "Eliminar Repartidor",
                html: "<h4>¿Está seguro que desea eliminar el registro?</h4>",
                showCancelButton: true,
                confirmButtonText: "<h5>Sí</h5>",
                cancelButtonText: "<h5>No</h5>",
                reverseButtons: true,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.value) {
                    resultado = true;
                    this.borrarDatos();
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    resultado = false;
                }
            });
            if (this._isMounted) {
                this.setState({ borrando: false });
            }
        }

        return resultado;
    };

    onRowSelect = (row, isSelected) => {
        let disabled = { ...this.state.disabled };
        disabled.Acciones = !isSelected;

        let selectedRepartidor = 0;
        let selectedRepEstatus = "";

        if (isSelected) {
            selectedRepartidor = row.Repartidor_Id;
            selectedRepEstatus = row.Estatus;
        }

        this._isMounted && this.setState({ disabled, selectedRepartidor, selectedRepEstatus });
    }

    onDoubleClick = (e, row, rowIndex) => {
        this.setState({ selectedRepartidor: row.Repartidor_Id, selectedRepEstatus: row.Estatus }, () => {
            this.actualizarDatos();
        });
    };

    filtrarRegistro = (event) => {
        const { value } = event.target;
        const { listaRepartidoresOrig } = this.state;

        let Datos = { ...this.state.Datos };
        Datos.busqueda.value = value.trim();

        let result = [];
        let listaRepartidores = [];
        if (value.trim().length > 0) {
            result = listaRepartidoresOrig.filter(item => item.Nombre.toUpperCase().indexOf(value.toUpperCase()) != -1);

            if (result.length > 0) {
                listaRepartidores = result;
            }

            if (!isNaN(value.trim())) {

                result = listaRepartidoresOrig.filter(item => parseInt(item.Repartidor_Id) == parseInt(value.trim()));
                if (result.length > 0) {
                    listaRepartidores = listaRepartidores.concat(result)
                        .reduce((newArray, item) => {
                            if (newArray.includes(item)) {
                                return newArray;
                            } else {
                                return [...newArray, item];
                            }
                        }, []);
                }
            }

            if (this._isMounted) {
                this.setState({ listaRepartidores, Datos });
            }
        } else {
            if (this._isMounted) {
                this.setState({ listaRepartidores: listaRepartidoresOrig, Datos });
            }
        }
    };

    onFocusInput = (event) => {
        event.target.value = this.state.buscar;
    };

    onSelectChanged = async (event) => {
        const { name, value } = event.target;

        let newAttributes = this.state.Datos[name].attributes;
        const Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });

        if (value > 0) {

            const response = await Repartidores_Lista(this.props.token, this.props.empresa.Id, value);
            if (response.Exitoso) {
                this._isMounted && this.setState({ listaRepartidores: response.Datos, listaRepartidoresOrig: response.Datos });
            } else {
                Notificacion.error(response.Mensaje);
            }
        }

        this._isMounted && this.setState({ Datos });
    };

    render() {
        const { Datos, listaRepartidores, listaCallCenter, menuId, opcionValidar, showModalSeguridad, paginaActual } = this.state;

        return (
            <RepartidorItfz
                token={this.props.token}
                menuId={menuId}
                opcionValidar={opcionValidar}
                showModalSeguridad={showModalSeguridad}
                onActionResultModal={this.onActionResultModal}
                handleCerrarModal={this.handleCerrarModal}
                listaRepartidores={listaRepartidores}
                listaCallCenter={listaCallCenter}
                Datos={Datos}
                onDoubleClick={this.onDoubleClick}
                onRowSelect={this.onRowSelect}
                actualizarDatos={this.actualizarDatos}
                ingresarDatos={this.ingresarDatos}
                handleBorrar={this.handleBorrar}
                filtrarRegistro={this.filtrarRegistro}
                onFocusInput={this.onFocusInput}
                onSelectChanged={this.onSelectChanged}
                paginaActual={paginaActual}
                onPageChange={this.cambiarPagina}
                onSizePerPageChange={this.cambiarTamanioPagina}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
    };
};

export default connect(mapStateToProps)(withRouter(memo(Repartidores)));
